// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3175":"css/app.6971","8765":"css/admin-app.6971"}[chunkId] + ".css";
};